// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FileUpload.css */

/* Overlay & Modal (varsayalım zaten ekliydi) */
.file-upload-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.file-upload-modal {
  background: #fff;
  width: 550px;
  max-width: 90%;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}
.modal-title {
  text-align: center;
  font-size: 20px;
  margin-bottom: 1rem;
}

/* Sürükle-bırak alanı (varsayalım var) */
.file-drop-area {
  border: 2px dashed #cccccc;
  border-radius: 6px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 1rem;
  background-color: #fafafa;
  position: relative;
}
.file-drop-area:hover {
  background-color: #f5f5f5;
}
.file-drop-area p {
  color: #555;
  font-size: 14px;
  pointer-events: none;
}
.file-input {
  display: none;
}

/* Dosya listesi (varsayalım var) */
.file-list {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fdfdfd;
  padding: 0.5rem;
  margin-bottom: 0.75rem;
}
.file-item {
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
}
.file-item:last-child {
  border-bottom: none;
}
.no-files {
  color: #999;
  font-size: 13px;
  text-align: center;
}

/* Uyarı metni (varsayalım var) */
.file-note {
  text-align: center;
  font-size: 12px;
  color: #777;
  margin-bottom: 0.75rem;
  margin-top: 0.5rem;
}

/* ------------ Aşağıyı mutlaka ekleyin ------------ */

/* Hata metni */
.error-text {
  color: #d0021b;
  font-size: 13px;
  text-align: center;
  margin-bottom: 0.75rem;
}

/* Buton satırı */
.button-row {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}
.analyze-btn {
  background-color: #3182ce;
  color: #fff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.analyze-btn:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
}
.analyze-btn:hover:enabled {
  background-color: #2b6cb0;
}
.close-btn {
  background-color: #e53e3e;
  color: #fff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.close-btn:disabled {
  background-color: #fcb4b4;
  cursor: not-allowed;
}
.close-btn:hover:enabled {
  background-color: #c53030;
}

.file-process-type-row {
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.file-process-type-select {
  padding: 0.3rem 0.7rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.file-list {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fdfdfd;
  padding: 0.5rem;
  margin-bottom: 0.75rem;
}

.file-item {
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-item:last-child {
  border-bottom: none;
}

.no-files {
  color: #999;
  font-size: 13px;
  text-align: center;
}

.remove-btn {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;;
  padding: 0;
  margin-left: auto;
  margin-right: 15px;
}

.remove-btn:hover {
  text-decoration: underline;
}

/* File size display */
.file-size {
  font-size: 13px;
  color: #555;
  margin-left: 15px;
  margin-right: 15px;
  justify-content: right;
  display: flex;
  align-items: center;
  flex-grow: 1;
  text-align: right;
}



/* Responsive (isteğe bağlı) */
@media (max-width: 600px) {
  .file-upload-modal {
    width: 90%;
    padding: 1rem;
  }
  .file-drop-area {
    height: 120px;
  }
  .file-list {
    max-height: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FileUpload/FileUpload.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sDAAsD;;AAEtD,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;;;AAIA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* FileUpload.css */\r\n\r\n/* Overlay & Modal (varsayalım zaten ekliydi) */\r\n.file-upload-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 999;\r\n}\r\n.file-upload-modal {\r\n  background: #fff;\r\n  width: 550px;\r\n  max-width: 90%;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);\r\n  box-sizing: border-box;\r\n}\r\n.modal-title {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Sürükle-bırak alanı (varsayalım var) */\r\n.file-drop-area {\r\n  border: 2px dashed #cccccc;\r\n  border-radius: 6px;\r\n  height: 150px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  margin-bottom: 1rem;\r\n  background-color: #fafafa;\r\n  position: relative;\r\n}\r\n.file-drop-area:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n.file-drop-area p {\r\n  color: #555;\r\n  font-size: 14px;\r\n  pointer-events: none;\r\n}\r\n.file-input {\r\n  display: none;\r\n}\r\n\r\n/* Dosya listesi (varsayalım var) */\r\n.file-list {\r\n  max-height: 150px;\r\n  overflow-y: auto;\r\n  border: 1px solid #eee;\r\n  border-radius: 4px;\r\n  background-color: #fdfdfd;\r\n  padding: 0.5rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n.file-item {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 14px;\r\n  color: #333;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n.file-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.no-files {\r\n  color: #999;\r\n  font-size: 13px;\r\n  text-align: center;\r\n}\r\n\r\n/* Uyarı metni (varsayalım var) */\r\n.file-note {\r\n  text-align: center;\r\n  font-size: 12px;\r\n  color: #777;\r\n  margin-bottom: 0.75rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n/* ------------ Aşağıyı mutlaka ekleyin ------------ */\r\n\r\n/* Hata metni */\r\n.error-text {\r\n  color: #d0021b;\r\n  font-size: 13px;\r\n  text-align: center;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n/* Buton satırı */\r\n.button-row {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n.analyze-btn {\r\n  background-color: #3182ce;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.5rem 1.5rem;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.analyze-btn:disabled {\r\n  background-color: #a0aec0;\r\n  cursor: not-allowed;\r\n}\r\n.analyze-btn:hover:enabled {\r\n  background-color: #2b6cb0;\r\n}\r\n.close-btn {\r\n  background-color: #e53e3e;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.5rem 1.5rem;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.close-btn:disabled {\r\n  background-color: #fcb4b4;\r\n  cursor: not-allowed;\r\n}\r\n.close-btn:hover:enabled {\r\n  background-color: #c53030;\r\n}\r\n\r\n.file-process-type-row {\r\n  margin-bottom: 1rem;\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n.file-process-type-select {\r\n  padding: 0.3rem 0.7rem;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n  font-size: 14px;\r\n}\r\n\r\n.file-list {\r\n  max-height: 150px;\r\n  overflow-y: auto;\r\n  border: 1px solid #eee;\r\n  border-radius: 4px;\r\n  background-color: #fdfdfd;\r\n  padding: 0.5rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.file-item {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 14px;\r\n  color: #333;\r\n  border-bottom: 1px solid #ddd;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.file-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.no-files {\r\n  color: #999;\r\n  font-size: 13px;\r\n  text-align: center;\r\n}\r\n\r\n.remove-btn {\r\n  background: none;\r\n  border: none;\r\n  color: red;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  font-size: 18px;;\r\n  padding: 0;\r\n  margin-left: auto;\r\n  margin-right: 15px;\r\n}\r\n\r\n.remove-btn:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* File size display */\r\n.file-size {\r\n  font-size: 13px;\r\n  color: #555;\r\n  margin-left: 15px;\r\n  margin-right: 15px;\r\n  justify-content: right;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-grow: 1;\r\n  text-align: right;\r\n}\r\n\r\n\r\n\r\n/* Responsive (isteğe bağlı) */\r\n@media (max-width: 600px) {\r\n  .file-upload-modal {\r\n    width: 90%;\r\n    padding: 1rem;\r\n  }\r\n  .file-drop-area {\r\n    height: 120px;\r\n  }\r\n  .file-list {\r\n    max-height: 120px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
